import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { ModalPropsMap, ModalTypeName } from '../../../View/Modal/ModalMap.js'

type ModalStackEntry = {
  modalType: ModalTypeName
  props: ModalPropsMap[ModalTypeName]
}

export interface ModalState {
  stack: ModalStackEntry[]
}

const initialState: ModalState = {
  stack: []
}

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: <T extends ModalTypeName>(state: ModalState, action: PayloadAction<{ modalType: T; props: ModalPropsMap[T] }>) => {
      state.stack.push(action.payload)
    },
    closeModal: (state: ModalState) => {
      state.stack.pop()
    }
  }
})

export const { openModal, closeModal } = modalSlice.actions
